/* eslint-disable max-lines */
import React, { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../utils/firebase';

const DEFAULT_TITLE = 'Pangkalan LPG 3 Kg Admin MyPertamina';

export const Suspensed = (Element, title) =>
  function suspense(props) {
    const screenName = title ? title + ' - ' + DEFAULT_TITLE : DEFAULT_TITLE;

    // Firebase v11: Use logEvent instead of setCurrentScreen
    logEvent(analytics, 'screen_view', {
      firebase_screen: screenName,
      firebase_screen_class: screenName,
    });

    return (
      <Suspense fallback={<div />}>
        <Helmet>
          <title>{screenName}</title>
        </Helmet>
        <Element {...props} />
      </Suspense>
    );
  };

export default {
  Error404: Suspensed(
    lazy(() => import('./Error404')),
    '404'
  ),
  Error403: Suspensed(
    lazy(() => import('./Error403')),
    '403'
  ),
  Login: Suspensed(
    lazy(() => import('./Login')),
    'Login'
  ),
  ForgotPassword: Suspensed(
    lazy(() => import('./ForgotPassword')),
    'Lupa Password'
  ),
  ResetPassword: Suspensed(
    lazy(() => import('./ResetPassword')),
    'Buat Kata Sandi Baru'
  ),
  ScanCodeMFA: Suspensed(
    lazy(() => import('./MfaScanCode')),
    'Scan Code MFA'
  ),
  Home: Suspensed(
    lazy(() => import('./Home')),
    'Dashboard'
  ),
  Stock: Suspensed(
    lazy(() => import('./Stock')),
    'Stok Produk'
  ),
  SettingHarga: Suspensed(
    lazy(() => import('./SettingHarga')),
    'Atur Harga Produk'
  ),
  InformasiBesaranSubsidi: Suspensed(
    lazy(() => import('./InformasiBesaranSubsidi')),
    'Informasi Besaran Subsidi'
  ),
  SettingBusinessType: Suspensed(
    lazy(() => import('./SettingBusinessType')),
    'Setting Business Type'
  ),
  FormSettingHarga: Suspensed(
    lazy(() => import('./SettingHarga/Form')),
    'Atur Harga Produk'
  ),
  FormSettingHargaSubPangkalan: Suspensed(
    lazy(() => import('./SettingHarga/FormSubPangkalan')),
    'Atur Harga Produk Subpangkalan'
  ),
  RegistrasiPangkalan: Suspensed(
    lazy(() => import('./RegistrasiMerchant')),
    'Registrasi Pangkalan'
  ),
  DetailRegistrasiMerchant: Suspensed(
    lazy(() => import('./RegistrasiMerchant/DetailRegistrasi')),
    'Detail Registrasi Merchant'
  ),
  VerificationRegistrationMerchant: Suspensed(
    lazy(() => import('./VerificationRegistrationMerchant')),
    'Verifikasi Data Merchant'
  ),
  DetailVerfication: Suspensed(
    lazy(() => import('./VerificationRegistrationMerchant/DetailVerification')),
    'Verifikasi Data Merchant'
  ),
  SettingMerchant: Suspensed(
    lazy(() => import('./SettingMerchant')),
    'Data Pangkalan LPG 3 Kg'
  ),
  AgenHistory: Suspensed(
    lazy(() => import('./SettingMerchant/AgenHistory')),
    'Riwayat Agen'
  ),
  DetailSetting: Suspensed(
    lazy(() => import('./SettingMerchant/DetailSetting')),
    'Data Pangkalan LPG 3 Kg'
  ),
  EditMerchant: Suspensed(
    lazy(() => import('./SettingMerchant/EditMerchant')),
    'Data Pangkalan LPG 3 Kg'
  ),
  MyPertaminaActivation: Suspensed(
    lazy(() => import('./AktivasiMyPertamina')),
    'Aktivasi MyPertamina'
  ),
  MyPertaminaActivationDetail: Suspensed(
    lazy(() => import('./AktivasiMyPertamina/DetailAktivasi')),
    'Aktivasi MyPertamina'
  ),
  MyPertaminaActivationBulk: Suspensed(
    lazy(() => import('./AktivasiMyPertamina/AktivasiSekaligus')),
    'Aktivasi MyPertamina'
  ),
  AktivasiPencatatanManual: Suspensed(
    lazy(() => import('./AktivasiPencatatanManual')),
    'Aktivasi Pencatatan Manual'
  ),
  UpdateStockMerchant: Suspensed(
    lazy(() => import('./UpdateStockMerchant')),
    'Update Stok Pangkalan'
  ),
  UploadStockMerchant: Suspensed(
    lazy(() => import('./UpdateStockMerchant/UploadStockMerchant')),
    'Unggah Data Stok Pangkalan'
  ),
  RegistrasiSekaligusMerchant: Suspensed(
    lazy(() => import('./RegistrasiMerchant/RegistrasiSekaligus')),
    'Registrasi Sekaligus'
  ),
  SinkronisasiMerchant: Suspensed(
    lazy(() => import('./SinkronisasiMerchant')),
    'Sinkronisasi Merchant'
  ),
  DetailSinkronisasiMerchant: Suspensed(
    lazy(() => import('./SinkronisasiMerchant/DetailMerchant')),
    'Sinkronisasi Merchant'
  ),
  SettingHargaSekaligus: Suspensed(
    lazy(() => import('./SettingHarga/SettingSekaligus')),
    'Setting Sekaligus'
  ),
  SettingHargaSekaligusSubPangkalan: Suspensed(
    lazy(() => import('./SettingHarga/SettingSekaligusSubPangkalan')),
    'Setting Sekaligus Subpangkalan'
  ),
  Faq: Suspensed(
    lazy(() => import('./Faq')),
    'Pengaturan FAQ'
  ),
  CreateFaq: Suspensed(
    lazy(() => import('./Faq/Form')),
    'Buat FAQ'
  ),
  UpdateFaq: Suspensed(
    lazy(() => import('./Faq/FormEdit')),
    'Edit FAQ'
  ),
  UpdateFaqSubpangkalan: Suspensed(
    lazy(() => import('./Faq/FormEditSubpangkalan')),
    'Edit FAQ Subpangkalan'
  ),
  User: Suspensed(
    lazy(() => import('./User')),
    'User'
  ),
  Permission: Suspensed(
    lazy(() => import('./Permission')),
    'Permission'
  ),
  Role: Suspensed(
    lazy(() => import('./Role')),
    'Role'
  ),
  AuditLog: Suspensed(
    lazy(() => import('./AuditLog')),
    'Audit Log'
  ),
  TermCondition: Suspensed(
    lazy(() => import('./TermCondition')),
    'Manajemen Kebijakan'
  ),
  TermConditionUpdate: Suspensed(
    lazy(() => import('./TermCondition/TermConditionUpdate')),
    'Manajemen Kebijakan'
  ),
  TermConditionPreview: Suspensed(
    lazy(() => import('./TermCondition/TermConditionPreview')),
    'Detail Kebijakan'
  ),
  UpdateSubPangkalan: Suspensed(
    lazy(() => import('./TermCondition/TermConditionUpdate')),
    'Manajemen Kebijakan SubPangkalan'
  ),
  Notification: Suspensed(
    lazy(() => import('./Notification')),
    'Notifikasi Login'
  ),
  AddNotification: Suspensed(
    lazy(() => import('./Notification/AddNotification')),
    'Tambah Notifikasi Login'
  ),
  EditNotification: Suspensed(
    lazy(() => import('./Notification/EditNotification')),
    'Ubah Notifikasi Login'
  ),
  Authentication: Suspensed(
    lazy(() => import('./Authentication')),
    'Authentication'
  ),
  Mfa: Suspensed(
    lazy(() => import('./Mfa')),
    'MFA TOTP'
  ),
  MerchantNotOnboarding: Suspensed(
    lazy(() => import('./MerchantNotOnboarding')),
    'Merchant Not Onboarding'
  ),
  Profile: Suspensed(
    lazy(() => import('./Profile')),
    'Profil'
  ),
  MfaConnectApp: Suspensed(
    lazy(() => import('./Mfa/ConnectApp')),
    'MFA Connect App'
  ),
  SetupAuthenticator: Suspensed(
    lazy(() => import('./SetupAuthenticator')),
    'Setup Authenticator'
  ),
  SettingSubMerchant: Suspensed(
    lazy(() => import('./SettingSubMerchant')),
    'Data Detail Sub Merchant'
  ),
  SearchSubMerchant: Suspensed(
    lazy(() => import('./SettingSubMerchant/Search')),
    'Search Sub Merchant'
  ),
  SubMerchantAggregate: Suspensed(
    lazy(() => import('./SubMerchantAggregate')),
    'Data Monitoring'
  ),
  SubMerchantActivation: Suspensed(
    lazy(() => import('./SubMerchantActivation')),
    'Aktivasi Fitur Pendaftaran Subpangkalan'
  ),
  FormSubMerchantActivation: Suspensed(
    lazy(() => import('./SubMerchantActivation/Form')),
    'Atur Aktivasi Subpangkalan'
  ),
  UploadSubMerchantActivation: Suspensed(
    lazy(() => import('./SubMerchantActivation/Upload')),
    'Upload Aktivasi Subpangkalan'
  ),
  AreaManagement: Suspensed(
    lazy(() => import('./AreaManagement')),
    'Manajemen Wilayah'
  ),
  NikManagement: Suspensed(
    lazy(() => import('./NikManagement')),
    'Manajemen Pelanggan'
  ),
  DetailCustomer: Suspensed(
    lazy(() => import('./NikManagement/Detail')),
    'Manajemen Pelanggan'
  ),
  BlockedCustomer: Suspensed(
    lazy(() => import('./NikManagement/NikBlocked')),
    'Manajemen Pelanggan'
  ),
  NikBlockedBulk: Suspensed(
    lazy(() => import('./NikManagement/NikBlockedBulk')),
    'Pemblokiran NIK Pelanggan'
  ),
  NikActivateBulk: Suspensed(
    lazy(() => import('./NikManagement/NikActivateBulk')),
    'Aktivasi NIK Pelanggan'
  ),
  NikLogStatus: Suspensed(
    lazy(() => import('./NikManagement/LogStatus')),
    'Log Status'
  ),
  CustomerSubmissionUnblock: Suspensed(
    lazy(() => import('./CustomerSubmissionUnblock')),
    'Pengajuan Buka Blokir Pelanggan'
  ),
  CustomerSubmissionUnblockDetail: Suspensed(
    lazy(() => import('./CustomerSubmissionUnblock/Detail')),
    'Rincian Pengajuan Buka Blokir Pelanggan'
  ),
  SettingReasonBlockId: Suspensed(
    lazy(() => import('./SettingReasonBlockId')),
    'Pengaturan Alasan Block'
  ),
  ProvinceTransactionRestriction: Suspensed(
    lazy(() => import('./ProvinceTransactionRestriction')),
    'Manajemen Pelanggan'
  ),
  ProvinceTransactionRestrictionDetail: Suspensed(
    lazy(() => import('./ProvinceTransactionRestriction/Detail')),
    'Rincian Data Pelanggan'
  ),
  GIGRActivation: Suspensed(
    lazy(() => import('./GIGRActivation')),
    'Aktivasi GI/GR'
  ),
  ActivationByMerchant: Suspensed(
    lazy(() => import('./GIGRActivation/ActivationByMerchant.jsx')),
    'Aktivasi Menu GI/GR'
  ),
  ActivationMerchantBulk: Suspensed(
    lazy(() => import('./GIGRActivation/ActivationMerchantBulk.jsx')),
    'Aktivasi Sekaligus Menu GI/GR'
  ),
  UpdateGRMerchant: Suspensed(
    lazy(() => import('./GIGRActivation/UpdateGRMerchant.jsx')),
    'Update GR Pangkalan'
  ),
  MAPFeatureActivation: Suspensed(
    React.lazy(() => import('./MAPFeatureActivation')),
    'Aktivasi Fitur MAP'
  ),
  MAPFeatureActivationBulk: Suspensed(
    React.lazy(() => import('./MAPFeatureActivation/FormBulkActivation.js')),
    'Bulk Aktivasi Fitur MAP'
  ),
};
